import { render } from "./orders_page1.vue?vue&type=template&id=559e0c60"
import script from "./orders_page1.vue?vue&type=script&lang=js"
export * from "./orders_page1.vue?vue&type=script&lang=js"

import "./orders_page1.vue?vue&type=style&index=0&id=559e0c60&lang=scss"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__